import {
    concatenatePath,
    DEFAULT_SORT_ORDER,
    findCategoryContainingSomeCategoryId,
    translateSortForOlderUrls,
    translateStatus,
} from './searchUtils';
import facetTypes from './search/facetTypes';
import find from 'lodash/find';
import { getFacetFromSearchQueryParameter } from './queryParams';
import paramTypes from './search/paramTypes';
import reject from 'lodash/reject';
import some from 'lodash/some';

// I want to keep these type here for now.  they need to be used for real soon and this is a start
// type DateRange = {
//     max: number,
//     maxSet: boolean,
//     min: number,
//     minSet: boolean,
// };

// type DistanceFilter = {
//     country: string,
//     measurement: string,
//     space: number,
//     zipcode: string,
// };

// type SearchQuery = {
//     analyticsTags: string[],
//     buyNow: boolean,
//     buyNowDate: number,
//     campaignId: string,
//     catalogId?: number,
//     categories: string[],
//     distance: DistanceFilter,
//     fullResults: boolean,
//     lat: string,
//     long: string,
//     // "options":{"status":["upcoming","live","online"],"shipping":["inHouseShipping"],"auctionHouse":[{"exclude":["5273","5291","5758","5851"],"include":[]}]}
//     options: any, // map[string]interface{}
//     page: number,
//     pagesize: number,
//     promoted?: boolean,
//     publishDate?: DateRange,
//     ranges?: any, // map[string]*Range
//     safeSearch: boolean,
//     saleDate?: DateRange,
//     searchTerm: string,
//     sort: string,
//     topRated: boolean,
//     useGeo: boolean,
// };

export const buildSearchQuery = ({
    catalogId = null,
    defaultSortOrder = DEFAULT_SORT_ORDER,
    pathname = '/search',
    queryParams = {},
    rawFacets = [],
    searchPageSize = 200,
}) => {
    // TODO: work catalog id into this
    const translateSort = translateSortForOlderUrls(queryParams.sort, defaultSortOrder);
    const status = translateStatus(queryParams, pathname);
    const searchQuery = {
        analyticsTags: ['web'],
        buyNow: queryParams.buyNow,
        buyNowDate: queryParams.buyNowDate,
        campaignId: queryParams.campaign_id,
        categories: [],
        distance: {},
        domesticFlatShipping: queryParams.domesticFlatShipping,
        options: {
            status,
        },
        page: queryParams.page || 1,
        pageSize: searchPageSize,
        publishDate: {},
        ranges: {},
        saleDate: {},
        searchTerm: queryParams.keyword ? queryParams.keyword : '',
        sort: translateSort,
    };

    if (catalogId) {
        searchQuery.catalogId = catalogId;
    }

    const categoryIds = queryParams.category_id;
    if (categoryIds) {
        const treeFacets = rawFacets.filter(f => f.id === facetTypes.CATEGORY_ID || f.id === facetTypes.ORIGIN_ID);
        const flatCategoryFacets = reject(
            rawFacets,
            f =>
                f.id === facetTypes.CATEGORY_ID ||
                f.id === facetTypes.ORIGIN_ID ||
                !f.options ||
                f.id === facetTypes.AUCTION_HOUSE_ID
        );

        categoryIds.split(',').forEach(categoryId => {
            const facetOption = find(flatCategoryFacets, f => some(f.options, o => o.id === categoryId));
            if (facetOption) {
                if (!searchQuery.options[facetOption.id]) {
                    searchQuery.options[facetOption.id] = [];
                }
                searchQuery.options[facetOption.id].push(categoryId);
            } else {
                const rootCategory = findCategoryContainingSomeCategoryId(categoryId, treeFacets);
                searchQuery.categories.push(concatenatePath(rootCategory, categoryId));
            }
        });
    }

    Object.keys(queryParams).forEach(key => {
        if (
            key === paramTypes.PAGE ||
            key === paramTypes.PAGE_SIZE_LEGACY_SUPPORT ||
            key === paramTypes.PAGE_SIZE ||
            key === paramTypes.CATEGORY_ID ||
            key === paramTypes.KEYWORD ||
            key === paramTypes.SORT ||
            key === paramTypes.STATUS ||
            key === paramTypes.CAMPAIGN_ID ||
            key === paramTypes.BUY_NOW ||
            key === paramTypes.BUY_NOW_DATE
        )
            return;

        const convertedKey = getFacetFromSearchQueryParameter(key);
        const isRangeFacet =
            convertedKey === facetTypes.ESTIMATED_PRICE_ID ||
            convertedKey === facetTypes.CURRENT_BID_ID ||
            convertedKey === facetTypes.HAMMER_PRICE_ID ||
            convertedKey === facetTypes.RESERVE;
        const isDistanceFacet = convertedKey === facetTypes.DISTANCE_ID;
        if (isRangeFacet) {
            const minMaxMatches = queryParams[key].match(/-?\d+/g);
            if (!searchQuery.ranges[convertedKey]) {
                searchQuery.ranges[convertedKey] = {};
            }
            const minValue = Number(minMaxMatches[0]);
            const maxValue = Number(minMaxMatches[1]);
            searchQuery.ranges[convertedKey].min = minValue === -1 ? null : minValue;
            searchQuery.ranges[convertedKey].max = maxValue === -1 ? null : maxValue;
        } else if (isDistanceFacet && queryParams[key] && queryParams[key].split) {
            const distanceOptions = queryParams[key].split(':');
            searchQuery.distance.country = distanceOptions[0];
            searchQuery.distance.zipCode = distanceOptions[1];
            searchQuery.distance.space = Number(distanceOptions[2]);
            searchQuery.distance.measurement = distanceOptions[3];
        } else if (key === paramTypes.PUBLISH_DATE_MIN) {
            searchQuery.publishDate.min = Number(queryParams[key]);
            searchQuery.publishDate.minSet = true;
        } else if (key === paramTypes.PUBLISH_DATE_MAX) {
            searchQuery.publishDate.max = Number(queryParams[key]);
            searchQuery.publishDate.maxSet = true;
        } else if (key === paramTypes.SALE_DATE_MIN) {
            searchQuery.saleDate.min = Number(queryParams[key]);
            searchQuery.saleDate.minSet = true;
        } else if (key === paramTypes.SALE_DATE_MAX) {
            searchQuery.saleDate.max = Number(queryParams[key]);
            searchQuery.saleDate.maxSet = true;
        } else if (queryParams[key] && queryParams[key].split) {
            const arrayParams = queryParams[key].split(',');
            searchQuery.options[convertedKey] = arrayParams;
        } else if (key === paramTypes.SHIPPING) {
            searchQuery.options[key] = [queryParams.shipping];
        }
    });

    return searchQuery;
};

export const isBuyNowQuery = searchQuery => {
    const isStartingSoonest = searchQuery.sort === 'saleStart';
    const isBINSaleType =
        !searchQuery.options ||
        !searchQuery.options['sale_type'] ||
        searchQuery.options['sale_type'].includes('BuyNow');
    return !isStartingSoonest && isBINSaleType;
};
